import React from 'react';
import axios from 'axios';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
// import { Switch, Route, Link, Redirect, withRouter } from 'react-router-dom';
import { Row, Col, Button, message } from 'antd';
// import { Row, Col, Button, Alert, message } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';

// import LoginForm from './LoginForm';
import RevealEmail from './RevealEmail';
import SendPasswordSet from './SendPasswordSet';
import SetPassword from './SetPassword';
// import ChooseFolioModal from './ChooseFolioModal';
import DepositLogin from './DepositLogin';
import DepositForm from './DepositForm';
import DepositSuccess from './DepositSuccess';
import DepositFail from './DepositFail';
import App from 'localcomponents/App';

class Login extends React.Component {
	state = {
		redirectHome: false,
		showFolioModal: false,
		chooseFromFolios: []
	}
	handleSubmit = (values) => {
		this.props.isLoading();
		axios.post(apiPath+'/auth', {
			Email: values.email,
			Password: values.password
		},{
			withCredentials: true
		}).then(result => {
			this.props.isDoneLoading();
			if (result.data.folios) {
				this.setState({
					showFolioModal: true,
					chooseFromFolios: result.data.folios
				});
			} else {
				this.setState({ redirectHome: true });
				this.props.history.push('/portal');
				location.reload();
			}
		}).catch(error => {
			this.props.isDoneLoading();
			console.error(error);
			message.error('Invalid credentials');
		});
	}

	handleChooseFolio = (folioId) => {
		this.props.isLoading();
		axios.post(apiPath+'/auth/withFolio', {FolioId: folioId},{withCredentials: true}).then(result => {
			this.props.isDoneLoading();
			this.setState({ redirectHome: true });
		}).catch(error => {
			this.props.isDoneLoading();
			console.error(error);
			message.error('Something went wrong, please try again');
		});
	}
	componentDidMount() {
		localStorage.removeItem('fieldProgramCart');
		axios.get(apiPath+'/logout', {withCredentials: true})
			.catch(console.error);
	}
	render() {
		if (this.state.redirectHome) return <Redirect to="/portal" />;
		// const path = this.props.location.pathname.split('/')[1];
		const relativePath = '';
		return (
			<App>
			<Row style={{marginTop: '16pt'}}>
				<Col xs={{span: 20, offset: 2}} sm={{span: 13, offset: 5}} style={{padding:'6vmin 0 12vmin 0'}}>
					<Switch>
						<Route path={relativePath+'/forgotemail'} component={RevealEmail} />
						<Route path={relativePath+'/forgotpassword'} component={SendPasswordSet} />
						<Route path={relativePath+'/setpassword/:token'} component={SetPassword} />
						<Route path={relativePath+'/depositlogin'} component={DepositLogin} />
						<Route path={relativePath+'/depositsuccess'} component={DepositSuccess} />
						<Route path={relativePath+'/depositfail'} component={DepositFail} />
						<Route path={'/depositform'} component={DepositForm} />
						<Route path="*" render={() =>
							<div>
								<p style={{fontSize: 22, textAlign: "center"}}>
								It looks like you are trying to make a payment or book a field program for Semester at Sea. </p>
								<br/>
								<p style={{fontSize: 22, textAlign: "center"}}>
								If you are a confirmed voyager on an upcoming voyage or a recent SAS alumni, please return to your community portal using the buttons below. To return to this Programs and Payments page, go to the bottom on the Home tab, and select <i>"Make a payment or view your itemized bill"</i>
								</p>
							</div>
						} />
					</Switch>
					<div style={{textAlign: 'center', paddingTop: '16pt'}}>
						<a href="https://semesteratsea.my.site.com/portal/TX_SiteLogin?startURL=%2Fportal%2FTargetX_Base__Portal"><Button type="dashed" style={{margin: 3}}>Student Community Portal</Button></a>
						<a href="https://semesteratsea.my.site.com/lllportal/TX_SiteLogin?startURL=%2Flllportal%2FTargetX_Base__Portal"><Button type="dashed" style={{margin: 3}}>Lifelong Learner Community Portal</Button></a>
						<a href="https://semesteratsea.my.site.com/stacultyportal/TX_SiteLogin?startURL=%2Fstacultyportal%2FTargetX_Base__Portal"><Button type="dashed" style={{margin: 3}}>Staculty Community Portal</Button></a>
					</div>
				</Col>
			</Row>
			</App>
		);
	}
}

export default withRouter(withSpin(Login));



// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx